import { ErrorBase } from './ErrorBase';

export class APIError extends ErrorBase {
  constructor({ message, cause }: { message: string; cause: Error }) {
    super({ message, cause });
    this.name = 'APIError';
  }
}
